/** Background image for fatal error component */
export const FATAL_ERROR_BACKGROUND_IMG = 'images/img/maintenance.jpg';
